import { Flex, Icon, Text } from '@chakra-ui/react';
import { RiAccountCircleFill } from '@react-icons/all-files/ri/RiAccountCircleFill';

type Props = {
  name?: string | null;
  email?: string | null;
};

const SidebarAccountHeader = ({ name, email }: Props) => (
  <Flex
    flexDir="column"
    gap="7.5px"
    bg="royalBlueDark"
    w="280px"
    mt="-7px"
    ml="-21px"
    p="10px 21px"
  >
    <Icon as={RiAccountCircleFill} boxSize="30px" color="white" />
    <Text color="white" fontSize="18px" fontWeight="semibold">
      {name}
    </Text>
    <Text color="white" fontSize="15px">
      {email}
    </Text>
  </Flex>
);

export default SidebarAccountHeader;
